import React, { useState } from "react";
import { TextField, Typography, MenuItem, Box, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import StyledButton from "./StyledButton";
import BusinessIcon from '@mui/icons-material/Business';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useSelector, useDispatch } from 'react-redux';
import { authorize, selectBranch } from "../../redux/authSlice";
import { useNavigate } from 'react-router-dom';

const OptionsForm = ({ onBack }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const [errorMessage, setErrorMessage] = useState('');
  const { branches, selectedBranch, loading } = useSelector((state) => state.auth);
  
  const handleBranchChange = (e) => {
    // Clear error message when user selects a branch
    if (errorMessage) {
      setErrorMessage('');
    }
    dispatch(selectBranch(e.target.value));
  };

  const handleConfirm = async () => {
    if (!selectedBranch) {
      setErrorMessage('Please select a branch to continue');
      return;
    }
    
    // Clear any existing error messages
    setErrorMessage('');
    
    const result = await dispatch(authorize(selectedBranch));
  
    if (authorize.fulfilled.match(result)) {
      navigate('/dashboard');
    } else {
      setErrorMessage(result.payload?.message || 'Authorization failed. Please try again.');
    }
  };

  return (
    <Box sx={{ width: '100%', maxWidth: 400 }}>
      <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <BusinessIcon sx={{ color: 'primary.main', fontSize: 32 }} />
        <Typography
          variant="h5"
          fontWeight="bold"
          sx={{
            color: 'primary.main',
            fontSize: { xs: '1.25rem', sm: '1.5rem' }
          }}
        >
          Select Branch to Login
        </Typography>
      </Box>
      
      <TextField
        select
        fullWidth
        name="ddSocietyBranch"
        label="Select Branch"
        variant="outlined"
        margin="normal"
        value={selectedBranch || ''}
        onChange={handleBranchChange}
        disabled={!branches || branches.length === 0}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: 2,
          }
        }}
      >
        {branches && branches.length > 0 ? (
          branches.map((branch) => (
            <MenuItem key={branch.id} value={branch.id}>
              {branch.branchName}
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled value="">
            No branches available
          </MenuItem>
        )}
      </TextField>
      
      <Box sx={{ mt: 4 }}>
        <StyledButton
          onClick={handleConfirm}
          text="Confirm"
          loading={loading}
          disabled={!selectedBranch || !branches || branches.length === 0}
        />
        
        {onBack && (
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
            <Button
              onClick={onBack}
              variant="text"
              startIcon={<ArrowBackIcon />}
              sx={{
                color: 'text.secondary',
                textTransform: 'none',
                fontWeight: 500,
                fontSize: '0.875rem',
                '&:hover': {
                  backgroundColor: 'transparent',
                  color: 'primary.main'
                }
              }}
            >
              Back to Login
            </Button>
          </Box>
        )}
      </Box>
      
      {errorMessage && (
        <Typography
          variant="body2"
          color="error"
          align="center"
          sx={{
            mt: 2,
            fontSize: '0.875rem',
            fontWeight: 500
          }}
        >
          {errorMessage}
        </Typography>
      )}
    </Box>
  );
};

export default OptionsForm;